import CustomTable from "../common/CustomTable";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  incomingChallanItemState,
  incomingHistoryPartyState,
  inventoryEntryPartIdState,
  modalTitle,
} from "../../utils/atoms/atoms";
import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getChallanItems, getPendingSentRecdById } from "../../api/incoming";
import { sentRecdHistoryColumns } from "../../utils/table/incomingItemsCols";

const IncomingHistoryModalBody = () => {
  const partEntryModalId = useRecoilValue(inventoryEntryPartIdState);
  const incomingHistoryParty = useRecoilValue(incomingHistoryPartyState);
  const incomingChallanItemsId = useRecoilValue(incomingChallanItemState);
  const setModalTitle = useSetRecoilState(modalTitle);

  const tableState = incomingChallanItemsId ? "challan" : "history";

  const {
    isLoading,
    data: partEntries,
    isSuccess,
  } = useQuery({
    queryKey: ["pending_by_id", incomingHistoryParty, partEntryModalId],
    queryFn: () =>
      getPendingSentRecdById(incomingHistoryParty, partEntryModalId),
    enabled:
      tableState === "history" && !!partEntryModalId && !!incomingHistoryParty,
    onSuccess: (data) => {
      if (data[0]?.emp_name) {
        setModalTitle(`${data[0].part_name} - ${data[0].drawing}`);
      } else {
        setModalTitle("Data not found");
      }
    },
  });

  const {
    isLoading: isChallanLoading,
    data: challanDetails,
    isSuccess: isChallanSuccess,
  } = useQuery({
    queryKey: ["challan_details", incomingChallanItemsId],
    queryFn: () => getChallanItems(incomingChallanItemsId),
    enabled: tableState === "challan" && !!incomingChallanItemsId,
  });

  const isLoadingFinal =
    tableState === "history" ? isLoading : isChallanLoading;
  const isSuccessFinal =
    tableState === "history" ? isSuccess : isChallanSuccess;
  const tableData = tableState === "history" ? partEntries : challanDetails;

  return (
    <React.Fragment>
      {isLoadingFinal ? (
        "Loading"
      ) : isSuccessFinal ? (
        <CustomTable data={tableData} columns={sentRecdHistoryColumns} />
      ) : (
        "Something went wrong"
      )}
    </React.Fragment>
  );
};

export default IncomingHistoryModalBody;
